import React from 'react'

export default function SwitchbuttonStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        .switch-button-wrapper { display: flex; }
        .switch-button-container {
          background-color: green;
          /*border: solid 0.3px green;*/
          display: flex;
          border-radius: 20px;
          padding: 1px;
          /*height: 20px;*/
        }
        .off { background-color: darkgrey; }
        .small { transform: scale(0.8); }

        .switch-status {
          font-size: 0.8rem;
          margin: auto;
          padding: 3px;
          text-align: left;
          width: 30px;
        }
        .circle-button {
          margin: auto;
          border-radius: 50px;
          border: none;
          width: 18px;
          height: 18px;
          background-color: transparent;
        }
        .circle-button.left { }
        .circle-button.right { }
        .on {
          width: 23px;
          height: 23px;
          background-color: whitesmoke;
        }
        .disabled-sb {
          pointer-events: none;
          opacity: 0.4;
        }
        .disabled-sb * { color: grey; }
      `}
      </style>
    </React.Fragment>
  )
}
